import React, { useState } from 'react';
import './App.css';
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Avatar
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

function App() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = () => {
    if (username === 'admin' && password === 'admin') {
      setIsLoggedIn(true);
    } else {
      alert('Invalid credentials');
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        background: 'linear-gradient(to right, #1e3c72, #2a5298)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {!isLoggedIn ? (
        <Paper
          elevation={6}
          sx={{
            padding: 4,
            width: 360,
            textAlign: 'center',
            borderRadius: 4,
          }}
        >
          <Avatar sx={{ bgcolor: '#1e3c72', margin: '0 auto 16px' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography variant="h5" gutterBottom>
            Sahyadri Login
          </Typography>

          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            variant="contained"
            fullWidth
            onClick={handleLogin}
            sx={{
              marginTop: 2,
              backgroundColor: '#1e3c72',
              '&:hover': {
                backgroundColor: '#16325c',
              },
            }}
          >
            Login
          </Button>
        </Paper>
      ) : (
        <Box textAlign="center">
          <Typography variant="h4" color="white" gutterBottom>
            Welcome, Sahyadri!
          </Typography>
          <Typography variant="subtitle1" color="white">
            You have successfully logged in.
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default App;
